<template>
  <div>
    <div class="row">
      <div class="col-md-12">
          <div class="card mb-5">
              <div class="card-body">
                  <h4 class="mt-0 header-title" @click="backParent" style="cursor: pointer">
                      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                      <span v-if="account.id === null"> Create Account Type</span>
                      <span v-else> Edit Account Type</span>
                  </h4>
                  <div class="row mt-5">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="type_code" class="col-form-label">Account Type</label>
                        <v-select :options="typeSelect" :reduce="type => type.meta.code" label="type" v-model="account.parent_code" id="type_code"/>
                        <div class="invalid-feedback">
                          Error
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="account_code" class="col-form-label">Code <span style="color:red">*</span></label>
                        <input class="form-control" type="text" id="account_code" v-model="account.type_code">
                      </div>
                      <div class="form-group">
                        <label for="account_name" class="col-form-label">Name <span style="color:red">*</span></label>
                        <input class="form-control" type="text" id="account_name" v-model="account.name">
                        <div class="invalid-feedback">
                          Error
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="card-footer">
                <button type="button" @click="updateAccount" class="btn btn-primary pull-right" v-if="account.id !== null">Update</button>
                <button type="button" @click="saveAccount" class="btn btn-primary pull-right" v-else>Save</button>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { chartAccountTypeUrl, getHeader } from '@/config'

export default {
  name: 'ChartOfAccountTypeForm',
  props: ['account'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    saveAccount: function () {
      axios.post(chartAccountTypeUrl, this.account, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    updateAccount: function () {
      axios.put(chartAccountTypeUrl + '/' + this.account.id, this.account, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  },
  computed: {
    ...mapState({
      chartOfAccountList: state => state.accounts.chartOfAccountList
    }),
    typeSelect: function () {
      var loop = []
      var array = this.chartOfAccountList.filter(c => c.hierarcy !== 4)
      for (let x = 0; x < array.length; x++) {
        var obj = {
          type: array[x].code + ' - ' + array[x].name,
          meta: {
            code: array[x].code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  }
}
</script>
